import { renderOptionGroup_unstable } from '@fluentui/react-combobox';
/**
 * Render the final JSX of TagPickerOptionGroup
 */ export const renderTagPickerOptionGroup = renderOptionGroup_unstable;
